import React, {Component} from 'react';

import './VideoPanel.scss';


import VideoPlayer from './videoPlayer/VideoPlayer';

class VideoPanel extends Component {

	constructor(props) {
		super(props);
		this.state = {
			selectedVideoIndex: this.props.selectedVideoIndex,

			panelPlayersWidth: undefined,
			panelPlayerHeight: undefined
		};

		this.videosCount = this.props.selectedVideos.length;
		this.videosReadyCount = 0;

		this.container = React.createRef();
	}

	/**
	 * Set size of panels
	 * @param width
	 * @param height
	 */
	setPanelPlayersSize = (width, height, isWindowResizing) => {
		if( isWindowResizing || !this.state.panelPlayersWidth || width > this.state.panelPlayersWidth || height > this.state.panelPlayerHeight) {
			this.setState({
				panelPlayersWidth: `${width * 100 / this.container.current.offsetWidth}%`,
				panelPlayerHeight: `${height * 100 / this.container.current.offsetHeight}%`
			})
		}
	};

	/**
	 * On Click to open the video swapping menu
	 * @param selectedVideoIndex - selectedVideoIndex
	 * @param selectedVideo - Selected video data
	 */
	onClickToggleSwapMenuOpen = (selectedVideoIndex, selectedVideo) => {
		this.setState({
			selectedVideoIndex
		});
		// Pause video
		this.props.pausePlayState();
		// Open sawp menu
		this.props.toggleIsSwapMenuOpen();
		// Set VideoPanel selected video index
		this.props.setSelectedVideoIndex(selectedVideoIndex);
		// Set selected video in swap menu
		this.props.setSwapMenuSelectedVideo(selectedVideo);
	};

	/**
	 * When 1 video is ready
	 */
	onSingleVideoReady = () => {
		++this.videosReadyCount;
		if( this.videosReadyCount === this.videosCount ){
			this.props.toggleVideoReady();
		}
	};

	componentDidMount(){
		// On mount -> select selected video for swap menu
		this.props.setSwapMenuSelectedVideo(this.props.selectedVideos[this.state.selectedVideoIndex]);
	}

	render() {
		return (
			<div className="videoPanelContent"
				 ref={this.container}
			>

				<div className={`videoPanelContent__selectedVideoHideLayer ${this.props.isSwapMenuOpen ? `videoPanelContent__selectedVideoHideLayer--visible` : ``}`}
					onClick={this.props.toggleIsSwapMenuOpen}
				>
				</div>

				<div
					className={`videoPanelContent__player videoPanelContent__player--left ${this.props.isSwapMenuOpen && this.state.selectedVideoIndex === 0 ? `videoPanelContent__player--selected` : '' }`}
					style={{
						width: this.state.panelPlayersWidth,
						height: this.state.panelPlayerHeight
					}}
				>
					<VideoPlayer
						src={this.props.selectedVideos[0].url}
						name={this.props.selectedVideos[0].name}
						fps={this.props.selectedVideos[0].fps}
						toggleVideoReady={this.onSingleVideoReady()}

						currentlyPlaying={this.props.currentlyPlaying}
						navTo={this.props.navTo}

						updatePlaybackTime={this.props.updatePlaybackTime}

						updateVideoDuration={this.props.updateVideoDuration}
						pausePlayState={this.props.pausePlayState}
						playPlayState={this.props.playPlayState}

						isSwapMenuOpen={this.props.isSwapMenuOpen}
						toggleIsSwapMenuOpen={this.onClickToggleSwapMenuOpen.bind(this, 0, this.props.selectedVideos[0])}

						setPanelPlayersSize={this.setPanelPlayersSize}
					/>
				</div>

				<div
					className={`videoPanelContent__player videoPanelContent__player--right ${this.props.isSwapMenuOpen && this.state.selectedVideoIndex === 1 ? `videoPanelContent__player--selected` : '' }`}
					style={{
						width: this.state.panelPlayersWidth,
						height: this.state.panelPlayerHeight
					}}
				>
					<VideoPlayer
						src={this.props.selectedVideos[1].url}
						name={this.props.selectedVideos[1].name}
						fps={this.props.selectedVideos[1].fps}

						toggleVideoReady={this.onSingleVideoReady()}

						currentlyPlaying={this.props.currentlyPlaying}
						navTo={this.props.navTo}

						isSwapMenuOpen={this.props.isSwapMenuOpen}
						toggleIsSwapMenuOpen={this.onClickToggleSwapMenuOpen.bind(this, 1, this.props.selectedVideos[1])}

						setPanelPlayersSize={this.setPanelPlayersSize}
					/>
				</div>
			</div>
		);
	}
}

export default VideoPanel;
